import { FootballIcon } from './FootballIcon';

/**
 * author: Google
 * id 3C0488C6-E807-401D-9689-7770550EC2E7
 * name football
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/football.svg
 * tags
 * - Sport 
 */
export const FootballAmericanIcon = FootballIcon;
export default FootballAmericanIcon